import { Controller } from "stimulus";
import { showLdp } from "../../helpers/ldp_navigation_helpers"
import {getState, setState} from '../../search_results/state'
import { mapListConnection } from '../../search_results/map_list_connection'
import { SearchItemContainer } from '../../search/search_item_container'
import { translations } from '../../translations.js.erb'
import { FlexmlsMap } from '../../map/flexmls_map'
import { markerManager } from '../../map/marker_manager'
import mapConverters from '../../map/map_converters'
import Filter from "../../filter";
import GlobalOverlayManager from "../../global_overlay_manager"
import { searchFormFlex } from '../../listings/search_form_flex'
import { nativeAppInterface } from "../../native_app_interface";

export default class extends Controller {

  map = null
  mapListConnection = null
  currentOpenMenu = null

  connect(evt) {
    this.load_google()

    if (this.map === null) {
      var defaultOptions = {
        contactId: window.mapSupport.contactId,
        currencySymbol: window.mapSupport.currencySymbol,
        mlsDefaultBounds: window.mapSupport.mlsDefaultBounds,
        translations: translations.map,
        loadingMessage: {
// These are causing problems when the map is not visible at startup
// When the summary view is the staring view, the map puts up the spinner
// until the clusters are finished loading.  On smaller phones, the map
// is loaded but not visible.  But the clusters wont finish loading until
// the map has become a visible part of the page.  For now, take this
// out.  We already have a "Loading..." msg when the turbo-frame is loading.
// If we need an indicator to show that clusters are in the process of
// loading, we can put it in at the turbo-frame level instead of the main
// page level (where the UIL is in charge of displaying it.)
//          start: showPageLoadingMsg,
//          stop: hidePageLoadingMsg
        },
        drawingCompleteCallback: this.drawingCompleteCallback.bind(this)
      };
      var mapOptions = $.extend({}, defaultOptions, {});
      this.map = new FlexmlsMap(document.getElementById('map'), mapOptions);

      this.map.init();
      $(document).off('click', '#overlayKeyBtn, .overlaysPopover, .moreMapToolsBtn, .shapesPopover');

      // Add map event handlers
      this.addMapEventHandlers();

      // This is a fresh map.  If there are overlays/shapes in the filter, we should draw them now.
      this.addFilterOverlayShapesToMap(getState('filter'))
      $(document).on('mouseenter', '#contains-MapOverlayShape li.select2-selection__choice', this.highlightOverlayShape.bind(this));
      $(document).on('mouseleave', '#contains-MapOverlayShape li.select2-selection__choice', this.unhighlightOverlayShape.bind(this));
      $(document).on('mouseenter', '#contains-drawings li.select2-selection__choice', this.highlightDrawnShape.bind(this));
      $(document).on('mouseleave', '#contains-drawings li.select2-selection__choice', this.unhighlightDrawnShape.bind(this));

      // Setup escape key handler for menu closing
      $(document).on('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeCurrentMenu();
        }
      });
    }

    // Check for the openDrawingTools param.
    const turboFrame = this.element.closest('turbo-frame');
    if (turboFrame) {
      const frameSrc = turboFrame.getAttribute("src");
      if (frameSrc) {
        // Parse the URL using the URL API
        const url = new URL(frameSrc, window.location.origin); // Ensure absolute URL
         // Use URLSearchParams to check for the 'openDrawingTools' parameter
        const params = url.searchParams;
        if (params.get('openDrawingTools') === 'true') {
          document.getElementById('drawOnMapBtn').click()
        }
      }
    }
  }

  disconnect() {
    this.map.resetShapesMenu();
    this.map.onMapUnload();
    // No map? No map bounds!  Otherwise, the next time we load the map, the same
    // map bounds could be loaded and we wouldn't update the clusters.
    setState('mapBounds',null);

    GlobalOverlayManager.clearAllFilteredShapes();
    $(document).off('mouseenter', '#contains-drawings li.select2-selection__choice');
    $(document).off('mouseleave', '#contains-drawings li.select2-selection__choice');
    $(document).off('mouseenter', '#contains-MapOverlayShape li.select2-selection__choice');
    $(document).off('mouseleave', '#contains-MapOverlayShape li.select2-selection__choice');
  }

  closeCurrentMenu() {
    if (this.currentOpenMenu) {
      $('#mapContextMenu').remove();
      $('#drawnShapesListMenu').remove();
      this.currentOpenMenu = null;
      // Also close the drawn shape manager when closing menu
      this.map.resetShapesMenu();
    }
  }

  getCurrentMenuElement() {
    if (this.currentOpenMenu === 'context') {
      return $('#mapContextMenu');
    } else if (this.currentOpenMenu === 'drawnShapes') {
      return $('#drawnShapesListMenu');
    }
    return null;
  }

  updateMenuState(menuType) {
    this.currentOpenMenu = menuType;
  }

  calculateMenuPosition(x, y, menuWidth = 200, menuHeight = 100) {
    const windowWidth = $(window).width();
    const windowHeight = $(window).height();
    const padding = 16;

    // Use the same simple approach as the shape editing menu
    // Ensure menu stays within screen boundaries on both sides
    const finalX = Math.max(padding, Math.min(x, windowWidth - menuWidth - padding));

    // For vertical positioning, try below first, then above if it doesn't fit
    let finalY = y;
    if (y + menuHeight > windowHeight - padding) {
      finalY = y - menuHeight;
      // If it still doesn't fit above, align with top edge
      if (finalY < padding) {
        finalY = padding;
      }
    }

    return { x: finalX, y: finalY };
  }

  clearTempMarkers(evt) {
    this.closeCurrentMenu();
    this.map.deleteTemporaryMarkersAndStuff();
  }

  drawShapes(evt) {
    // Something outside the maps controller asked us to draw shapes
    this.closeCurrentMenu();
    $('.shapesPopover').trigger('click')
  }

  async filterChangedCallback(newExpressions, oldExpressions) {

    let newFilter = new Filter(newExpressions, mapSupport.locationFields);

    var added   = new Filter(Filter.expressionsAdded(oldExpressions, newExpressions), mapSupport.locationFields);
    var removed = new Filter(Filter.expressionsRemoved(oldExpressions, newExpressions), mapSupport.locationFields);

    var deleteAnnotations = true;
    newExpressions.forEach( function(expression) {
      if (expression.type === 'shape' || expression.field === 'MapOverlayShape') {
        deleteAnnotations = false;
      }
    });

    if (deleteAnnotations) {
      setState('annotations',[]);
      sessionStorage.removeItem('annotations')
    }

    if(getState('mapBounds') === null){
      setState('filter', newFilter);

    } else if(typeof this.map === 'undefined'){
      setState('filter', newFilter);

      if(added.locations().length > 0 || removed.locations().length > 0) {
        setState('mapBounds', null);
      }

    } else {
      let shapesAddedOrRemoved = false
      if (added.shapes().length > 0 || removed.shapes().length > 0) {
        this.map.refreshMapShapes()
        shapesAddedOrRemoved = true
      }

      if (added.locations().length > 0 || removed.locations().length > 0) {
        // Remove unfiltered shapes first.  When shape operators/conjunctions change,
        // we might end up deleting a valid shape.  But if we do the remove first,
        // we will properly add the shape back to the map.
        this.removeUnfilteredShapesFromMap(removed)
        // Then add the filtered shapes
        await this.addFilterOverlayShapesToMap(added)
        shapesAddedOrRemoved = true
      }

      if (shapesAddedOrRemoved) {
        this.map.freeze()
        let shapesAdded = (added.locations().length > 0 || added.shapes().length > 0)
        let shapesRemoved = (removed.locations().length > 0 || removed.shapes().length > 0)
        if (shapesRemoved && newFilter.locations().length === 0 && newFilter.shapes().length === 0) {
          this.map.moveMapToMlsDefaultBounds().then((bounds) => {
            setState('mapBounds', bounds);
            this.map.unfreeze();
            this.map.updateMap();
          })
        } else {
          var self = this
          let bounds1 = this.map.getDrawnShapesBounds();
          let bounds2 = GlobalOverlayManager.getTotalMapOverlayShapeBounds();
          if (bounds1 === null) {
            // They cant both be null or we wouldnt be here
            bounds1 = bounds2
          } else if (bounds2 !== null) {
            // If both are NOT null, combine them.
            bounds1.union(bounds2)
          }

          this.map.updateMap({bounds: bounds1}).done(function() {
            self.map.moveMapToBoundary(bounds1).then((bounds) => {
              setState('mapBounds', bounds);
              self.map.unfreeze();
            })
            .catch((e) => {
              console.log(e.message)
            });
          });
        }
      }
      this.map.unfreeze()
    }
  }

  filterChanged(data) {
    // Someone changed the filter.  Close the menu if it is open.
    this.closeCurrentMenu()
    // Both flexmls map and this controller handle filter changes.
    // We are refreshing the map shapes here so we do not influence the 'live' route.
    // This use to get called at the end of a filterChangedCallback.
    // TODO: When we go live with the new route, we should revisit this and possibly move this into flexmls_map's filterChanged function. Or move that function here.
    this.filterChangedCallback(data.detail.newValue._data, data.detail.oldValue._data);
  }

  drawingCompleteCallback(filter, newBounds, annotation) {
    this.map.freeze();

      // Make a copy of annotations so the state's actual annotations value
      // doesn't change until we call setState.
      var annotations = JSON.parse(JSON.stringify(getState('annotations')));

    if (annotation) {
      annotations.push(annotation);
      setState('annotations', annotations);
      sessionStorage.setItem('annotations',JSON.stringify(annotations))
    }

    setState('filter', filter);

    this.map.moveMapToBoundary(newBounds).then((bounds) => {

      // Since the map is frozen, the bounds need to be updated manually.
      setState('mapBounds', bounds);

      this.map.unfreeze();

      this.map.updateMap().done(() => {
        setState('listingCountTotal', this.map.mappedListingCount());
      });
    });
  }

  mapZoomIn(evt){
    this.closeCurrentMenu();
    this.map.googleMap.setZoom(this.map.googleMap.getZoom() + 1);
  }

  mapZoomOut(evt){
    this.closeCurrentMenu();
    this.map.googleMap.setZoom(this.map.googleMap.getZoom() - 1);
  }

  showListingCard(evt) {
    if (evt.detail === null) {
      markerManager.deletePopupMarkers();
    } else {
      markerManager.addPreviewMarker(evt.detail);
    }
  }

  showLdpFromMap(evt) {
    this.map.resetShapesMenu()
    var target = $(evt.target)

    if (
        (target.hasClass('marker-preview-wrapper-above') || target.hasClass('marker-preview-wrapper-below') ) ||
        (target.closest('.rsArrowLeft').length) ||
        (target.closest('.rsArrowRight').length)||
        (target.closest('.saveListingLink').length) ) {
      // let addToCollection deal with it
    } else {
      evt.preventDefault()
      // Prevent multiple fast clicks from attempting more than one load of the LDP
      if ($('#priorityOverlay').hasClass('loading')) return
      $('#priorityOverlay').addClass('loading')

      // The url for the listing detail page is stored in a data attribute on
      // the preview. If the preview is clicked, we need to look up the dom to
      // find it, but if the outermost wrapper was clicked, we need to look
      // inside the clicked element.
      var urlHolder = $(evt.target).closest('[data-listing-show-url]')

      if(urlHolder.length < 1) {
        urlHolder = $(evt.target).find('[data-listing-show-url]')
      }

      var requestUrl = new URL(urlHolder.attr('data-listing-show-url'))

      // TODO: Fix this inside the preview card
      if (requestUrl.searchParams.has('listing_id')) requestUrl.searchParams.delete('listing_id')
      if (requestUrl.searchParams.has('view')) requestUrl.searchParams.delete('view')

      var listingUrl = requestUrl.href
      let browserUrl = listingUrl

      // TODO: Add the listing id as an attribute somewhere in the preview card
      let pattern = /\/listings\/(\d{26})/
      let match_result = listingUrl.match(pattern)
      let listingId = match_result[1]

      var mapItem = markerManager.getMarkerInfoById(listingId)
      listingUrl = listingUrl.replace("/listings/","/listing_detail/");
      if (mapItem !== null) {
        mapItem.listingUrl = listingUrl
        mapItem.pushState = true
        mapItem.browserUrl = browserUrl
        showLdp(mapItem)
      } else {
        console.log("No marker information found. This should not happen.")
      }
    }
  }

  requestPreviousListing(evt) {
    var currentListingId = evt.detail
    var previousMarkerMapItem = markerManager.getPreviousMarkerInfo(currentListingId)

    if (previousMarkerMapItem === null) {
      // We should not get here because the previous button should have been disabled if
      // there were no more.  But just in case.
      console.log("No previous map markers found");
    }

    // Someone hit the prev button on an LDP.  Replace the current LDP with the new LDP
    var listingUrl = window.location.href;
    listingUrl = listingUrl.replace(currentListingId, previousMarkerMapItem.listingId);

    // Update the URL in the browser
    history.replaceState('','',listingUrl)
    // Adjust the URL to get the details frame
    listingUrl = listingUrl.replace("/listings/","/listing_detail/");

    previousMarkerMapItem.listingUrl = listingUrl
    previousMarkerMapItem.pushState = false;
    showLdp(previousMarkerMapItem);
  }

  requestNextListing(evt) {
    var currentListingId = evt.detail
    var nextMarkerMapItem = markerManager.getNextMarkerInfo(currentListingId)

    if (nextMarkerMapItem === null) {
      // We should not get here because the next button should have been disabled if
      // there were no more.  But just in case.
      console.log("No more map markers found");
    }

    // Someone hit the next button on an LDP.  Replace the current LDP with the new LDP
    var listingUrl = window.location.href;
    listingUrl = listingUrl.replace(currentListingId, nextMarkerMapItem.listingId);

    // Update the URL in the browser
    history.replaceState('','',listingUrl)

    // Adjust the URL to get the details frame
    listingUrl = listingUrl.replace("/listings/","/listing_detail/");

    nextMarkerMapItem.listingUrl = listingUrl
    nextMarkerMapItem.pushState = false;
    showLdp(nextMarkerMapItem);
  }

  refreshMapFromList(evt) {
    // The data action for this should only be defined if we are a newsfeed or notifications
    // It will update the map with the newly loaded items in the table/summary results.
    this.map.updateMap();
  }

  requestListingIds(event) {
    let listingIds = markerManager.getListingIds();
    const response = new CustomEvent(event.detail.returnEvent, {detail: { listingIds: listingIds }})
    window.dispatchEvent(response)
  }

  async addFilterOverlayShapesToMap(filter) {
    // This needs to be async so that we dont leave here until
    // all of the items have been added to the map.  Calls that
    // happen after this use the map shapes to define the map bounds.

    const promises = [];

    // Process MapOverlayShape entries
    const shapePromises = filter.locations()
        .filter(obj => obj.field === 'MapOverlayShape')
        .map(expression => (async () => {
            const shape = await GlobalOverlayManager.getMyMapOverlayShape(
                expression.condition.replaceAll("'", "")
            );
            GlobalOverlayManager.addFilterOverlayShapeToMap(shape.Id, shape);
        })());
    promises.push(...shapePromises);

    // Wait for all operations to complete
    await Promise.all(promises);

    // Toggle visibility to visible for all shapes
    this.toggleAllShapesVisibility(true);
  }

  toggleAllShapesVisibility(visible) {
    this.map.drawingManager.toggleVisibility(visible);
    GlobalOverlayManager.toggleFilteredOverlayShapesVisibility(visible);
    GlobalOverlayManager.toggleUnfilteredOverlayShapesVisibility(visible);
  }

  removeAllShapes() {
    GlobalOverlayManager.clearAllFilteredShapes();
    this.map.deleteAllDrawings();
    setState('annotations',[])
    sessionStorage.removeItem('annotations')
  }

  removeUnfilteredShapesFromMap(filter) {
    // Make a copy of annotations so the state's actual annotations value
    // doesn't change until we call setState.
    let annotations = JSON.parse(JSON.stringify(getState('annotations')));
    filter.locations().filter(obj => obj['field'] === 'MapOverlayShape').forEach(expression => {
      GlobalOverlayManager.removeFilterOverlayShapeFromMap(expression['condition'].replaceAll("'",""))
      annotations = annotations.filter(a => a.Match.Substring !== expression['condition']);
    });
    setState('annotations',annotations)
    sessionStorage.setItem('annotations',JSON.stringify(annotations))
  }

  highlightOverlayShape(event) {
    let overlayShapes = $(event.currentTarget).find('[data-shape]')
    if (overlayShapes.length > 0) {
      GlobalOverlayManager.fillOverlayShape($(overlayShapes[0]).attr('data-shape').replaceAll("'",""), 0.9)
    }
  }

  unhighlightOverlayShape(event) {
    let overlayShapes = $(event.currentTarget).find('[data-shape]')
    if (overlayShapes.length > 0) {
      GlobalOverlayManager.fillOverlayShape($(overlayShapes[0]).attr('data-shape').replaceAll("'",""), 0.15)
    }
  }

  highlightDrawnShape(event) {
    let shapes = $(event.currentTarget).find('[data-shape]')
    if (shapes.length > 0) {
      this.map.highlightDrawnShape($(shapes[0]).attr('data-shape'))
    }
  }

  unhighlightDrawnShape(event) {
    let shapes = $(event.currentTarget).find('[data-shape]')
    if (shapes.length > 0) {
      this.map.unhighlightDrawnShape($(shapes[0]).attr('data-shape'))
    }
  }

  displayOverlayManager(event) {
    event.preventDefault();
    this.map.displayOverlayManager(event.detail);
  }

  newOverlayCreated(event) {
    // We have created a new overlay.
    let overlay = event.detail.overlay

    if (nativeAppInterface.isNative()) {
      nativeAppInterface.shapeConvertedToOverlay(overlay);
    }

    // Make a copy of annotations so the state's actual annotations value
    // doesn't change until we call setState.
    var annotations = JSON.parse(JSON.stringify(getState('annotations')));

    // Copy the current values from the location search box
    let searchLocationValues = $('#locationSearch').val() || [];

    // Add each shape to the annotations
    for (const shape of overlay.Shapes){
      let newAnnotation = {
        "Type": "Overlay",
        "Match": {
          "Substring": "'" + shape.Id + "'"
        },
        "Attributes": {
          "Shape": shape.Id,
          "Overlay": overlay.Id,
          "ShapeName": shape.Name,
          "Color": shape.Color
        }
      }

      annotations.push(newAnnotation)
      // Add the value to the locationSearch select2
      searchLocationValues.push('MapOverlayShape_' + shape.Id)

      // This is mimicicing what happens when you select an item in the location box - While the box is open and you
      // check an item, it adds the item to its underlying select and to the overlayShapesSelect.
      let locationOption = `<option value="MapOverlayShape_${shape.Id}">${overlay.Name} - ${shape.Name} (Map Overlay Shape)</option>`
      $('#locationSearch').append($(locationOption))
      let option = `<option value="'${shape.Id}'" selected="selected" data-color="#${shape.Color}">${shape.Name}</option>`
      $('#overlayShapesSelect').append($(option))

      let drawnShapeMatch = this.getMatchingDrawnPolygon(shape)
      if (drawnShapeMatch.length > 0) {
        let shapeDefinition = drawnShapeMatch.val()
         drawnShapeMatch.remove()
         annotations = annotations.filter(annotation => {
          if (!annotation?.Match?.Substring) {
            return true
          }
          return annotation.Match.Substring !== shapeDefinition
        });
      }
    } // Done processing the shapes in the overlay.

    setState('annotations', annotations);
    sessionStorage.setItem('annotations',JSON.stringify(annotations))

    this.triggerFilterPanelUpdates(searchLocationValues)

    toast.success('Overlay created successfully.');
  }

  overlayUpdated(event) {
    // We have updated an existing overlay.
    let overlay = event.detail.overlay

    if (nativeAppInterface.isNative()) {
      nativeAppInterface.shapeConvertedToOverlay(overlay);
    }

    // Make a copy of annotations so the state's actual annotations value
    // doesn't change until we call setState.
    var annotations = JSON.parse(JSON.stringify(getState('annotations')));

    // Copy the current values from the location search box
    let searchLocationValues = $('#locationSearch').val() || [];

    for (const shape of overlay.Shapes){
      // Only add the shapes that were added to the overlay.  We can tell which
      // ones those are by matching the shape definitions.
      let drawnShapeMatch = this.getMatchingDrawnPolygon(shape)
      if (drawnShapeMatch.length > 0) {
        let shapeDefinition = drawnShapeMatch.val()
        // Remove the drawn shape annotation
        annotations = annotations.filter(annotation => {
          if (!annotation?.Match?.Substring) {
            return true
          }
          return annotation.Match.Substring !== shapeDefinition
        });
        // Remove the shape from the select
        drawnShapeMatch.remove();

        // Add an annotation for the overlay shape
        let newAnnotation = {
          "Type": "Overlay",
          "Match": {
            "Substring": "'" + shape.Id + "'"
          },
          "Attributes": {
            "Shape": shape.Id,
            "Overlay": overlay.Id,
            "ShapeName": shape.Name,
            "Color": shape.Color
          }
        }
        annotations.push(newAnnotation)

        // Add the value to the locationSearch select2
        searchLocationValues.push('MapOverlayShape_' + shape.Id)

        // This is mimicicing what happens when you select an item in the location box - While the box is open and you
        // check an item, it adds the item to its underlying select and to the overlayShapesSelect.
        let locationOption = `<option value="MapOverlayShape_${shape.Id}">${overlay.Name} - ${shape.Name} (Map Overlay Shape)</option>`
        $('#locationSearch').append($(locationOption))
        let option = `<option value="'${shape.Id}'" selected="selected" data-color="#${shape.Color}">${shape.Name}</option>`
        $('#overlayShapesSelect').append($(option))
      }
    }

    setState('annotations', annotations);
    sessionStorage.setItem('annotations',JSON.stringify(annotations))

    this.triggerFilterPanelUpdates(searchLocationValues)

    toast.success('Overlay updated successfully.');
  }

  triggerFilterPanelUpdates(searchLocationValues) {
    // Update the overlayShapes container but dont process the results.  That will
    // happen when we trigger the locationSearch
    $('#overlayShapesSelect').trigger(
      {
        type: 'change',
        workInProgress: true
      });

    // Tell the locationSearch there are new values
    $('#locationSearch').val(searchLocationValues).trigger('change')
    // Process the changes as if you added them from the select2 and
    // are now done.
    $('#locationSearch').trigger('select2:close')
  }

  getMatchingDrawnPolygon(shape) {
    let drawnShapeMatch = $('#drawingsSelect option[value="' + shape.Geometry + '"]')
    if (drawnShapeMatch.length > 0) {
      return drawnShapeMatch
    }
    let possibleMatches = $('#drawingsSelect option[value^="polygon"]').filter(function() {
      // If it is a polygon with the same name, mark it as a possible match.
      return $(this).text() === shape.Name
    })
    if (possibleMatches.length === 0) {
      // We didnt find the shape in the drawingsSelect.
      console.log("No matching drawn shape found for new overlay shape: " + shape.Name)
      return []
    }
    let matchingShapes = $()

    possibleMatches.each(function() {
      let drawnShapeGeometry = $(this).val()
      let drawnPoints = drawnShapeGeometry.match(/[0-9.-]+\s[0-9.-]+/g)
      let shapePoints = shape.Geometry.match(/[0-9.-]+\s[0-9.-]+/g)
      if (drawnPoints.length !== shapePoints.length) {
        return // Skip if different number of points. Obviously, this is not a match.
      }

      // Check decimal places in coordinate strings
      let drawnDecimals = drawnPoints[0].split(' ').map(n => n.split('.')[1]?.length || 0)
      let shapeDecimals = shapePoints[0].split(' ').map(n => n.split('.')[1]?.length || 0)
      if (drawnDecimals[0] === shapeDecimals[0] && drawnDecimals[1] === shapeDecimals[1]) {
        // Same decimal precision was used, so exact string match already failed
        return;
      }

      // Different precision used, check if points match within tolerance
      let matches = drawnPoints.every((point, i) => {
        let [drawnLat, drawnLng] = point.split(' ').map(Number);
        let [shapeLat, shapeLng] = shapePoints[i].split(' ').map(Number);
        return Math.abs(drawnLat - shapeLat) < 0.000001 &&
                Math.abs(drawnLng - shapeLng) < 0.000001
      })

      if (matches) {
        matchingShapes = matchingShapes.add($(this))
      }
    })
    return matchingShapes
  }

  load_google() {
    // We only want to load the google script once.  With turboframes,
    // we could end up loading this multiple times without this check.
    if (!window.google) {
      const script = document.createElement('script');

      // Default key
      let keystring = "client=gme-fbsdata";

      // SCC key
      if (Flexmls.currentUser.mls_id == "20220727192737510867000000") {
        keystring = "key=AIzaSyBXiwAVI0znxgnvMQ7CRT4zGYP2UFd2KpM";
      }

      script.src = 'https://maps.googleapis.com/maps/api/js?v=3&' + keystring + '&libraries=drawing,geometry';
      script.async = false;
      script.defer = true;

      script.onload = () => {
      // You can initialize your Google Maps functionality here
      };

      document.body.appendChild(script);
    } else {
    }
  }

  addMapEventHandlers() {
    // Add a click handler to detect what was clicked on the map
    this.map.googleMap.addListener('click', (event) => {
      this.handleMapClick(event);
    });

    // Add a mousemove handler to detect what is under the mouse cursor
    this.map.googleMap.addListener('mousemove', (event) => {
      this.handleMapMouseMove(event);
    });
  }

  handleMapMouseMove(event) {
    // Detect what features are under the mouse cursor and highlight accordingly
    // But don't highlight/unhighlight when drawing is in progress
    if (this.map.drawingManager && this.map.drawingManager.drawingInProgress()) {
      return;
    }

    const mouseLatLng = event.latLng;

    // Use the same feature detection logic as handleMapClick
    const featuresUnderMouse = this.detectClickedFeatures(event);

    // First, unhighlight all overlay shapes
    const allOverlays = GlobalOverlayManager.data.overlaysOnTheMap;
    const filteredOverlayShapes = GlobalOverlayManager.data.filteredOverlayShapesOnTheMap;

    // Unhighlight all overlay shapes
    Object.keys(allOverlays).forEach(key => {
      allOverlays[key].forEach(googleShape => {
        try {
          googleShape.setOptions({ fillOpacity: 0.15 }); // Default opacity
        } catch (error) {
          console.log('Error setting opacity for overlay shape:', error);
        }
      });
    });

    Object.keys(filteredOverlayShapes).forEach(key => {
      filteredOverlayShapes[key].forEach(googleShape => {
        try {
          googleShape.setOptions({ fillOpacity: 0.25 }); // Default opacity
        } catch (error) {
          console.log('Error setting opacity for filtered overlay shape:', error);
        }
      });
    });

    // Unhighlight all drawn shapes
    if (this.map.drawingManager && this.map.drawingManager.drawings) {
      this.map.drawingManager.drawings.forEach(drawing => {
        try {
          drawing.setOptions({ fillOpacity: 0.5 }); // Default opacity
        } catch (error) {
          console.log('Error setting opacity for drawn shape:', error);
        }
      });
    }

    // Highlight features under mouse
    featuresUnderMouse.forEach(feature => {
      try {
        feature.shape.setOptions({ fillOpacity: 0.7 });
      } catch (error) {
        console.log('Error highlighting feature:', error);
      }
    });
  }

  handleMapClick(event) {
    // Don't show context menu if drawing is in progress
    if (this.map.drawingManager && this.map.drawingManager.drawingInProgress()) {
      return;
    }

    // Close existing menus
    mapConverters.closeGoogleInfoWindows()
    this.closeCurrentMenu();
    this.map.resetShapesMenu();

    // Save the latlng
    let clickLatLng = event.latLng;

    // Use Google to find features at the click point
    let clickPoint = new google.maps.LatLng(clickLatLng.lat(), clickLatLng.lng());

    // What shapes did we click on
    let clickedFeatures = this.detectClickedFeatures(event);

    // Close any existing menu before showing a new one
    this.closeCurrentMenu();

    // Check for markers first (they have highest priority) - only on touch devices
    if (Modernizr.touch) {
      const markerFeatures = [];
      this._detectMarkers(event, markerFeatures);

      if (markerFeatures.length > 0) {
        // If there's a marker at the click point, let the marker handle it
        // Stop the event to prevent Google Maps from processing it (e.g., POI info windows)
        event.stop();
        this.closeCurrentMenu();
        return;
      }
    }

    // Only filter shapes if we need to process them (no markers found)
    const drawnShapes = clickedFeatures.filter(feature => feature.type.includes('Drawn Shape'));
    const overlayShapes = clickedFeatures.filter(feature => feature.type.includes('Overlay Shape'));

    if (clickedFeatures.length === 1 && drawnShapes.length === 1) {
      // Stop event propagation to prevent Google's place info windows
      event.stop();

      // Trigger the shape's click event directly to let the drawing manager handle it
      const shape = drawnShapes[0].shape;
      const forwardedEvent = {
        domEvent: {
          pageX: event.domEvent.pageX,
          pageY: event.domEvent.pageY,
          clientX: event.domEvent.clientX,
          clientY: event.domEvent.clientY,
          target: event.domEvent.target,
          currentTarget: event.domEvent.currentTarget,
          type: 'click'
        },
        latLng: event.latLng,
        stop: event.stop
      };
      google.maps.event.trigger(shape, 'click', forwardedEvent);
    } else if (clickedFeatures.length > 0) {
      // Stop event propagation to prevent Google's place info windows
      event.stop();

      this.showContextMenu(event, clickedFeatures);
    } else {
      // No shapes or markers - let Google handle the place click
      // Google will automatically close any existing info windows and open new ones
      this.closeCurrentMenu();
    }
  }

  showContextMenu(event, features) {
    // Remove any existing context menu
    $('#mapContextMenu').remove();
    $('#drawnShapesListMenu').remove();

    // Create the context menu
    const menu = $('<div id="mapContextMenu" class="map-context-menu"></div>');

    // Add menu items for each feature
    features.forEach(feature => {
      const menuItem = this.createContextMenuItem(feature, event);
      menu.append(menuItem);
    });

    // Add the menu to the page
    $('body').append(menu);

    // Calculate optimal position using estimated dimensions
    const clickX = event.domEvent.pageX;
    const clickY = event.domEvent.pageY;
    const estimatedMenuWidth = 250; // Fixed width for consistency
    const estimatedMenuHeight = 50 + (features.length * 40); // Estimate height based on number of items
    const position = this.calculateMenuPosition(clickX, clickY, estimatedMenuWidth, estimatedMenuHeight);

    menu.css({
      left: position.x + 'px',
      top: position.y + 'px'
    });

    // Update menu state
    this.updateMenuState('context');
  }

  showDrawnShapeManagementMenu(event, drawnShapes) {
    // Remove any existing context menu
    $('#mapContextMenu').remove();
    $('#drawnShapesListMenu').remove();

    // Create a list menu showing all the shapes that were clicked
    const menu = $('<div id="drawnShapesListMenu" class="map-context-menu"></div>');

    // Add menu items for each drawn shape
    drawnShapes.forEach(shapeData => {
      const menuItem = this.createDrawnShapeListItem(shapeData, event);
      menu.append(menuItem);
    });

    // Add the menu to the page
    $('body').append(menu);

    // Calculate optimal position using estimated dimensions
    const clickX = event.domEvent.pageX;
    const clickY = event.domEvent.pageY;
    const estimatedMenuWidth = 250; // Fixed width for consistency
    const estimatedMenuHeight = 50 + (drawnShapes.length * 40); // Estimate height based on number of items
    const position = this.calculateMenuPosition(clickX, clickY, estimatedMenuWidth, estimatedMenuHeight);

    // Only set the dynamic positioning properties
    menu.css({
      left: position.x + 'px',
      top: position.y + 'px'
    });

    // Update menu state
    this.updateMenuState('drawnShapes');
  }

  createDrawnShapeListItem(shapeData, originalMapEvent) {
    const shape = shapeData.shape;
    const item = $('<div class="context-menu-item"></div>');

    // Get the shape color
    const color = shape.get('fillColor') || shape.get('strokeColor') || '#000000';
    const shapeName = shape.get('shapeName') || 'Unknown Shape';

    // Create color circle
    const colorCircle = $('<div class="color-circle"></div>').css({
      backgroundColor: color
    });

    // Create shape name
    const nameSpan = $('<span class="shape-name"></span>').text(shapeName);

    // Create action link
    const actionText = 'Edit shape';
    const actionLink = $('<a href="#" class="action-link edit-shape"></a>').text(actionText);

    // Create a container for the circle and name to keep them together
    const leftContainer = $('<div class="left-container"></div>');

    // Build the structure correctly from the start
    leftContainer.append(colorCircle, nameSpan);
    item.append(leftContainer, actionLink);

    // Add click handler for the entire menu item
    item.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleDrawnShapeListItemAction(shape, originalMapEvent);
      this.closeCurrentMenu();
    });

    return item;
  }

  handleDrawnShapeListItemAction(shape, originalMapEvent) {

    // Create a forwarded click event using the original map event coordinates
    const forwardedEvent = {
      domEvent: {
        pageX: originalMapEvent.domEvent.pageX,
        pageY: originalMapEvent.domEvent.pageY
      },
      latLng: originalMapEvent.latLng,
      stop: originalMapEvent.stop,
      stopImmediatePropagation: originalMapEvent.stopImmediatePropagation
    };

    // Trigger the click event on the shape to show the drawn shape management menu
    google.maps.event.trigger(shape, 'click', forwardedEvent);

  }

  createContextMenuItem(feature, originalMapEvent) {
    const item = $('<div class="context-menu-item"></div>');

    // Get the shape color
    const color = feature.shape.get('fillColor') || feature.shape.get('strokeColor') || '#000000';
    const shapeName = feature.shape.get('shapeName') || 'Unknown Shape';

    // Create color circle
    const colorCircle = $('<div class="color-circle"></div>').css({
      backgroundColor: color
    });

    // Create shape name
    const nameSpan = $('<span class="shape-name"></span>').text(shapeName);

    // Create action link based on feature type
    let actionText, actionClass;
    if (feature.type === 'Filtered Overlay Shape') {
      actionText = translations.map.remove_from_filter;
      actionClass = 'remove-filter';
    } else if (feature.type === 'Overlay Shape') {
      actionText = translations.map.add_to_filter;
      actionClass = 'add-filter';
    } else if (feature.type.includes('Drawn Shape')) {
      actionText = 'Edit shape';
      actionClass = 'edit-shape';
    } else {
      actionText = 'Action';
      actionClass = 'default-action';
    }

    const actionLink = $('<a href="#" class="action-link ' + actionClass + '"></a>').text(actionText);

    // Create a container for the circle and name to keep them together
    const leftContainer = $('<div class="left-container"></div>');

    // Build the structure correctly from the start
    leftContainer.append(colorCircle, nameSpan);
    item.append(leftContainer, actionLink);

    // Add click handler for the entire menu item
    item.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleContextMenuAction(feature, actionText, originalMapEvent);
      this.closeCurrentMenu();
    });

    return item;
  }

  cleanupRightLeftContent() {
    this.closeCurrentMenu();
  }

  /* ------------------------------------------------------------ */
  /* ------------------- Context menu methods ------------------- */
  /* ------------------------------------------------------------ */

  handleContextMenuAction(feature, action, originalMapEvent) {
    if (feature.type.includes('Drawn Shape') && action === 'Edit shape') {
      this._handleDrawnShapeEdit(feature, originalMapEvent);
    } else if (feature.type.includes('Overlay Shape')) {
      if (action === translations.map.add_to_filter) {
        this._handleOverlayShapeAddition(feature);
      } else if (action === translations.map.remove_from_filter) {
        this._handleOverlayShapeRemoval(feature);
      }
    }
  }

  _handleDrawnShapeEdit(feature, originalMapEvent) {
    // Add a small delay to let the map click handler finish
    setTimeout(() => {
      const forwardedEvent = {
        domEvent: {
          pageX: originalMapEvent.domEvent.pageX,
          pageY: originalMapEvent.domEvent.pageY,
          clientX: originalMapEvent.domEvent.clientX,
          clientY: originalMapEvent.domEvent.clientY,
          target: originalMapEvent.domEvent.target,
          currentTarget: originalMapEvent.domEvent.currentTarget,
          type: 'click'
        },
        latLng: originalMapEvent.latLng,
        stop: originalMapEvent.stop,
        stopImmediatePropagation: originalMapEvent.stopImmediatePropagation
      };
      google.maps.event.trigger(feature.shape, 'click', forwardedEvent);
    }, 10); // 10ms delay
  }

  _handleOverlayShapeAddition(feature) {
    let overlayShape = GlobalOverlayManager.getLoadedMyMapOverlayShape(feature.overlayShapeId.substring(0,26));
    if (overlayShape !== null) {
      let filter = getState('filter');
      let results = filter.addMapOverlayShapeToFilter(overlayShape);
      let newBounds = this._calculateCombinedBounds(feature.shape);

      this._handleExistingOverlayShapes(filter, newBounds);
      this._overlayAddedToFilterFromMap(filter, newBounds, results.annotation);
    } else {
      toast.error('Could not match map shape with an overlay shape');
    }
  }

  _calculateCombinedBounds(shape) {
    let newBounds = this.map.getDrawnShapesBounds();
    let moreBounds = GlobalOverlayManager.getTotalMapOverlayShapeBounds(shape);
    if (newBounds === null) {
      // They cant both be null or we wouldnt be here
      newBounds = moreBounds
    } else if (moreBounds !== null) {
      // If both are NOT null, combine them.
      newBounds.union(moreBounds)
    }
    return newBounds;
  }

  _handleExistingOverlayShapes(filter, newBounds) {
    if ($('#overlayShapesSelect').hasClass('dont_serialize')) {
      if ($('#overlayShapesSelect option').length > 0) {
        // This will make sure that the annotations match what are currently in the select2 list
        this.refreshAnnotations('Overlay');
      }
      // If the checkbox was off, we need to add other items in the list to the filter.
      $('#overlayShapesSelect option').each(function() {
        let value = $(this).val();
        let text = $(this).text();
        let existingOS = GlobalOverlayManager.getLoadedMyMapOverlayShape(value.replace(/'/g, ''));
        if (existingOS !== null) {
          let exisingResults = filter.addMapOverlayShapeToFilter(existingOS);
          // Convert the shape data to a Google Maps Polygon for bounds calculation
          let tempGoogleShape = GlobalOverlayManager.convertShapeToGooglePolygon(existingOS);
          let thisShapesBounds = GlobalOverlayManager.getTotalMapOverlayShapeBounds(tempGoogleShape);
          newBounds.union(thisShapesBounds)
        }
      });
    }
  }

  _handleOverlayShapeRemoval(feature) {
    this._overlayRemovedFromFilterFromMap(feature.overlayShapeId, feature.shape)
  }

  // Apparently the map cannot tell us what we clicked on if they are shapes that we
  // have drawn.  (My map overlays are still part of that.)  So we have to detect
  // what we clicked on by checking the shapes that are on the map.
  detectClickedFeatures(event) {
    const features = [];
    const clickPoint = event.latLng;

    // Use Google Maps' built-in feature detection
    try {
      // Always check shapes (markers are handled separately in handleMapClick)
      this._detectOverlayShapes(clickPoint, features);
      this._detectDrawnShapes(clickPoint, features);

      // Sort features by z-index to determine which is on top
      features.sort((a, b) => b.zIndex - a.zIndex);
    } catch (error) {
      toast.error('Unable to process map click:', error);
    }

    return features;
  }

  _detectOverlayShapes(clickPoint, features) {
    // Check overlay shapes from GlobalOverlayManager
    const allOverlays = GlobalOverlayManager.data.overlaysOnTheMap;
    const filteredOverlayShapes = GlobalOverlayManager.data.filteredOverlayShapesOnTheMap;

    // Create a map to track which shapes we've already processed
    const processedShapes = new Map();

    // First, process individual filtered overlay shapes (highest priority)
    this._processFilteredOverlayShapes(filteredOverlayShapes, clickPoint, features, processedShapes);

    // Then process regular overlays, but skip if already processed as filtered
    this._processRegularOverlayShapes(allOverlays, clickPoint, features, processedShapes);
  }

  _processFilteredOverlayShapes(filteredOverlayShapes, clickPoint, features, processedShapes) {
    const keys = Object.keys(filteredOverlayShapes);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const shapes = filteredOverlayShapes[key];
      for (let j = 0; j < shapes.length; j++) {
        const googleShape = shapes[j];
        try {
          // Skip invisible shapes to prevent menu interactions
          if (googleShape.getVisible() === false) continue;

          if (google.maps.geometry.poly.containsLocation(clickPoint, googleShape)) {
            processedShapes.set(key, true);
            features.push({
              type: 'Filtered Overlay Shape',
              shape: googleShape,
              overlayId: key,
              overlayShapeId: googleShape.get('overlayShapeId'),
              zIndex: googleShape.get('zIndex') || 0
            });
          }
        } catch (error) {
          toast.error('Error processing filtered overlay shape:', error);
        }
      }
    }
  }

  _processRegularOverlayShapes(allOverlays, clickPoint, features, processedShapes) {
    const parentOverlayIds = Object.keys(allOverlays);
    for (let i = 0; i < parentOverlayIds.length; i++) {
      const parentOverlayId = parentOverlayIds[i];
      const shapes = allOverlays[parentOverlayId];
      for (let j = 0; j < shapes.length; j++) {
        const googleShape = shapes[j];
        try {
          // Skip invisible shapes to prevent menu interactions
          if (googleShape.getVisible() === false) continue;

          if (google.maps.geometry.poly.containsLocation(clickPoint, googleShape)) {
            if (!processedShapes.has(googleShape.get('overlayShapeId'))) {
              features.push({
                type: 'Overlay Shape',
                shape: googleShape,
                overlayId: parentOverlayId,
                overlayShapeId: googleShape.get('overlayShapeId'),
                zIndex: googleShape.get('zIndex') || 0
              });
            }
          }
        } catch (error) {
          toast.error('Error processing unfiltered overlay shape:', error);
        }
      }
    }
  }

  _detectDrawnShapes(clickPoint, features) {
    // Check drawn shapes from the drawing manager
    if (this.map.drawingManager && this.map.drawingManager.drawings) {
      const drawings = this.map.drawingManager.drawings;
      for (let index = 0; index < drawings.length; index++) {
        const drawing = drawings[index];
        try {
          this._checkDrawnShapeType(drawing, clickPoint, features, index);
        } catch (error) {
          toast.error('Error processing drawn shapes', error);
        }
      }
    }
  }

  _checkDrawnShapeType(drawing, clickPoint, features, index) {
    if (drawing.getVisible() === false) return;
    // Check if it's a circle
    if (drawing.getCenter && drawing.getRadius) {
      const center = drawing.getCenter();
      const radius = drawing.getRadius();
      const distance = google.maps.geometry.spherical.computeDistanceBetween(clickPoint, center);
      if (distance <= radius) {
        features.push({
          type: 'Drawn Shape (Circle)',
          shape: drawing,
          zIndex: drawing.get('zIndex') || 0
        });
      }
    } else if (drawing.getPath && drawing.getPath().getLength && drawing.getPath().getLength() > 0) {
      if (google.maps.geometry.poly.containsLocation(clickPoint, drawing)) {
        features.push({
          type: 'Drawn Shape (Polygon)',
          shape: drawing,
          zIndex: drawing.get('zIndex') || 0
        });
      }
    } else if (drawing.getBounds) {
      if (drawing.getBounds().contains(clickPoint)) {
        features.push({
          type: 'Drawn Shape (Rectangle)',
          shape: drawing,
          zIndex: drawing.get('zIndex') || 0
        });
      }
    }
  }

  _detectMarkers(event, features) {
    // Check if any listing markers are at the click point
    if (typeof markerManager !== 'undefined' && markerManager.getListingMarkers) {
      const clickX = event.domEvent.clientX;
      const clickY = event.domEvent.clientY;
      const listingMarkers = markerManager.getListingMarkers();

      // Early exit optimization: stop checking once we find a marker
      for (let i = 0; i < listingMarkers.length; i++) {
        const marker = listingMarkers[i];
        try {
          // Use the marker's containsPoint method for accurate detection
          if (marker.label && marker.label.labelDiv_) {
            if (marker.containsPoint(clickX, clickY)) {
              features.push({
                type: 'Listing Marker',
                marker: marker,
                listingId: marker.listingId,
                zIndex: 1000 // Markers should have higher priority than shapes
              });
              // Early exit - we found a marker, no need to check others
              break;
            }
          }
        } catch (error) {
          // Ignore errors for individual markers
        }
      }
    }
  }

  /* ------------------------------------------------------------ */
  /* -------------- Methods for adding overlays ----------------- */
  /* ------------------------------------------------------------ */
  _overlayAddedToFilterFromMap(filter, newBounds, annotation) {
    // A lot of the prep work has been done.  This is actually puts stuff in place.
    this.map.freeze();

    // Make a copy of annotations so the state's actual annotations value
    // doesn't change until we call setState.
    var annotations = JSON.parse(JSON.stringify(getState('annotations')));

    if (annotation) {
      annotations.push(annotation);
      setState('annotations', annotations);
      sessionStorage.setItem('annotations',JSON.stringify(annotations))
    }

    setState('filter', filter);

    // Make shapes visible when overlay shapes are added to filter (same as when drawing starts)
    this.toggleAllShapesVisibility(true);

    this.map.moveMapToBoundary(newBounds).then((bounds) => {
      // Since the map is frozen, the bounds need to be updated manually.
      setState('mapBounds', bounds);

      this.map.unfreeze();

      this.map.updateMap().done(() => {
        setState('listingCountTotal', this.map.mappedListingCount());
      });
    });

    this._addItemToOverlaysFilterContainer(annotation)
    this._addItemToLocationSearchItem(annotation)
  }

  _addItemToLocationSearchItem(annotation) {
    let searchLocationValues = $('#locationSearch').val() || [];
    let value = 'MapOverlayShape_' + annotation.Attributes.Shape;
    let label = annotation.Attributes.ShapeName || value;

    // Add the option if it doesn't exist
    if ($('#locationSearch option[value="' + value + '"]').length === 0) {
      let newOption = new Option(label, value, true, true);
      $('#locationSearch').append(newOption);
    }

    // Set the value, but do NOT trigger 'change'
    if (!searchLocationValues.includes(value)) {
      searchLocationValues.push(value);
      $('#locationSearch').val(searchLocationValues);
    }
  }

  _addItemToOverlaysFilterContainer(annotation) {
    // Update the overlayShapesSelect container to show the new shape
    let $overlayShapesSelect = $('#overlayShapesSelect')
    let collapsibleElement = $($overlayShapesSelect.closest('.c-card')[0])
    collapsibleElement.find('.c-collapsible__content.filter_item_container').find('*').removeClass('dont_serialize');
    SearchItemContainer.expandContainer(collapsibleElement);
    SearchItemContainer.checkContainer($overlayShapesSelect.closest('.c-card'), true);

    // Existing values and our new value
    let overlayShapeValues = $overlayShapesSelect.val() || [];
    let newOverlayShapeValue = `'${annotation.Attributes.Shape}'`;

    // Only add the option if it doesn't already exist in the select
    // It could already be here if we had the overlays disabled in the filter form.
    if (!$overlayShapesSelect.find(`option[value="${newOverlayShapeValue}"]`).length) {
      let newOverlayShapeOption = `<option value="${newOverlayShapeValue}" selected="selected" data-color="#${annotation.Attributes.Color}">${annotation.Attributes.ShapeName}</option>`
      $overlayShapesSelect.append($(newOverlayShapeOption))
      overlayShapeValues.push(newOverlayShapeValue)
    }

    // Always update the select value and refresh select2 to ensure sync
    $overlayShapesSelect.val(overlayShapeValues)
    SearchItemContainer.updateSelectSummary($overlayShapesSelect)
  }


  /* ------------------------------------------------------------ */
  /* ----- Methods for removing overlays via map shapes menu ---- */
  /* ------------------------------------------------------------ */
  _overlayRemovedFromFilterFromMap(overlayShapeId, mapShape) {

    let filter = getState('filter');

    filter.removeShapeByCondition("'" + overlayShapeId + "'");

    // Remove the shape from the annotations
    let annotations = JSON.parse(JSON.stringify(getState('annotations')));
    let annotation = annotations.filter(a => a.Match.Substring == "'" + overlayShapeId + "'");
    if (annotation.length > 0) {
      annotation = annotation[0]
    }
    annotations = annotations.filter(a => a.Match.Substring !== "'" + overlayShapeId + "'");
    setState('annotations',annotations)
    sessionStorage.setItem('annotations',JSON.stringify(annotations))

    // Remove the shape from the global overlay manager
    GlobalOverlayManager.removeFilterOverlayShapeFromMap(overlayShapeId);

    let newBounds = this._calculateCombinedBounds(mapShape);

    this.map.freeze();
    setState('filter', filter);

    this.map.moveMapToBoundary(newBounds).then((bounds) => {
      // Since the map is frozen, the bounds need to be updated manually.
      setState('mapBounds', bounds);

      this.map.unfreeze();

      this.map.updateMap().done(() => {
        setState('listingCountTotal', this.map.mappedListingCount());
      });
    });

    // Only call these methods if we have a valid annotation
    if (annotation && annotation.Attributes) {
      this._removeItemFromOverlaysFilterContainer(annotation)
      this._removeItemFromLocationSearchItem(annotation)
    }
  }

  _removeItemFromOverlaysFilterContainer(annotation) {
    let $overlayShapesSelect = $('#overlayShapesSelect')
    let valueToRemove = `'${annotation.Attributes.Shape}'`;
    let overlayShapeValues = ($overlayShapesSelect.val() || [])
    $overlayShapesSelect.find(`option[value="${valueToRemove}"]`).remove()
    overlayShapeValues = overlayShapeValues.filter(value => value !== valueToRemove);
    $overlayShapesSelect.val(overlayShapeValues)
    SearchItemContainer.updateSelectSummary($overlayShapesSelect)
    SearchItemContainer.checkContainer($overlayShapesSelect.closest('.c-card'), $overlayShapesSelect.find('option:selected').length > 0);
  }

  _removeItemFromLocationSearchItem(annotation) {
    let searchLocationValues = $('#locationSearch').val() || [];
    let value = 'MapOverlayShape_' + annotation.Attributes.Shape;
    searchLocationValues = searchLocationValues.filter(v => v !== value);
    $('#locationSearch').val(searchLocationValues);
  }

  myLocation(evt) {
    this.closeCurrentMenu();
    // Trigger the myLocation functionality by calling the existing handler in flexmls_map
    if (this.map && this.map.myLocationClickEventHandler) {
      this.map.myLocationClickEventHandler(evt);
    }
  }

  refreshAnnotations(type) {
    // We are probably adding things to the annotations that were no there
    // because the parent container is unchecked.  If we are here, we want
    // the annotations to include all existing Select2 data matching the specified type.
    // (drawnshapes or overlay shapes)
    // First, start from scratch
    searchFormFlex.removeAnnotations(type);
    // Then read the select2 data and recreate the annotations
    searchFormFlex.recreateAnnotations(type);
  }

}
